import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M21 14l-9 7l-9 -7l3 -11l3 7h6l3 -7l3 11","key":"svg-0"}]]

/**
 * IconBrandGitlab
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItYnJhbmQtZ2l0bGFiIgo+CiAgPHBhdGggc3Ryb2tlPSJub25lIiBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIiAvPgogIDxwYXRoIGQ9Ik0yMSAxNGwtOSA3bC05IC03bDMgLTExbDMgN2g2bDMgLTdsMyAxMSIgLz4KPC9zdmc+) - https://tabler.io/icons/icon/brand-gitlab
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconBrandGitlab = createReactComponent('outline', 'brand-gitlab', 'BrandGitlab', __iconNode);

export default IconBrandGitlab;